import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { Loading } from 'components/Loading';

import { Modal, Flexer } from '@ontruck/orc';

import { StyledFieldWrapper, StyledSuccess } from './styled';

import { zipToCity } from 'redux/modules/addresses/effects';

// NOTE: This is the default for spain for backwards compatibility
// Maybe we want something else...
const DEFAULT_ZIPCODE_REGEXP = '^[0-9]{5}';

let typingTimer;
class ModalAddressForm extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    call2action: PropTypes.string,
    defaultZip: PropTypes.string,
    show: PropTypes.bool,
    checkOnlyZipCode: PropTypes.bool,
    address: PropTypes.object,
    zipToCity: PropTypes.func,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    intl: PropTypes.any,
    zipcodeRE: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      zipcodeRE: new RegExp(DEFAULT_ZIPCODE_REGEXP),
      postalCodeError: false,
      city: '',
      region: '',
      label: '',
      loading: false,
      address: {},
      callOnClose: true,
      errors: {},
      dirty: {},
      country: 'ES',
    };
    this.t = props.intl.messages.components.ModalAddressForm;
  }

  componentDidMount() {
    this.setState({ zipcodeRE: new RegExp(this.props.zipcodeRE || DEFAULT_ZIPCODE_REGEXP) });
    if (this.props.show && this.postalCodeField && this.postalCodeField.focus) {
      this.postalCodeField.focus();
    }
  }

  componentWillReceiveProps(nextProps = {}) {
    if (!this.props.show && nextProps.show && !!nextProps.address) {
      this.setState({
        address: !!nextProps.address ? nextProps.address : {},
        city: !!nextProps.address.city ? nextProps.address.city : '',
        region: '',
        label: !!nextProps.address.label ? nextProps.address.label : '',
        postalCodeError: false,
        loading: false,
        callOnClose: true,
        errors: {},
        dirty: {},
      });
      setTimeout(() => {
        if (nextProps.defaultZip) {
          this.guessCity(nextProps.defaultZip);
        } else {
          if (this.postalCodeField && this.postalCodeField.focus) {
            this.postalCodeField.focus();
          }
        }
      });
    }
  }

  validate() {
    const { postalCodeError, loading } = this.state;

    const { company_name, address_line, zipcode, city } = this.state.address;

    const { checkOnlyZipCode = false } = this.props;

    const extraValidations = checkOnlyZipCode
      ? {}
      : { company_name: !company_name, address_line: !address_line, city: !city };

    this.setState({
      ...this.state,
      dirty: {},
      errors: {
        ...this.errors,
        zipcode: !zipcode,
        ...extraValidations,
      },
    });

    const addressAndCompanyValidations = checkOnlyZipCode ? true : company_name && address_line;

    return !!zipcode && addressAndCompanyValidations && !postalCodeError && !loading;
  }

  dirtify(field) {
    this.setState((prevState) => ({
      dirty: Object.assign({}, prevState.dirty, { [field]: true }),
    }));
  }

  getError(field) {
    return (this.state.errors[field] && !this.state.dirty[field] && this.t.errors[field]) || '';
  }

  setAddress(
    changes,
    callback = () => {
      /*noop*/
    }
  ) {
    this.setState({ address: { ...this.state.address, ...changes } }, callback);
  }

  guessCity(e, { value = '' }) {
    clearTimeout(typingTimer);
    const zipcode = value.toUpperCase();
    const { country } = this.state;

    this.dirtify('zipcode');
    this.setAddress({ zipcode }, () => {
      typingTimer = setTimeout(() => {
        this.setState({ loading: true, errors: {} }, () => {
          this.props
            .zipToCity(zipcode, country)
            .then(({ city, enabled, region, label }) => {
              this.setState({
                postalCodeError: false,
                city,
                region,
                label,
                loading: false,
                errors: {},
                dirty: {},
              });
            })
            .catch(() => {
              this.setState({
                errors: { zipcode: true },
                dirty: {},
                postalCodeError: true,
                city: '',
                region: '',
                label: '',
                loading: false,
              });
            });
        });
      }, 1000);
    });
  }

  handleKeyUp(e) {
    const key = e.keyCode || e.which;
    if (key === 13) {
      return this.validate() && this.handleSubmit();
    }
  }

  handleSubmit() {
    this.setState({ callOnClose: false, errors: {} }, () => {
      return this.props
        .onSave({
          ...this.state.address,
          url: `NEW-${Date.now()}`,
          contact_phone:
            (this.state.address.contact_phone || '').length === 1
              ? ''
              : this.state.address.contact_phone,
          city: this.state.city || undefined,
          label: this.state.label || undefined,
          zipcode: ((this.state.address && this.state.address.zipcode) || '').replace(/ /g, ''),
          country: this.state.country,
        })
        .catch((err) => {
          this.setState({ callOnClose: true }, () => {
            if (err.response && typeof err.response.json === 'function') {
              err.response
                .json()
                .catch(() => {
                  /*noop*/
                })
                .then((errors) => {
                  this.setState({ errors, dirty: {} });
                });
            }
          });
        });
    });
  }

  render() {
    const { postalCodeError, city, loading, callOnClose, address, country } = this.state;

    const {
      title = '',
      call2action = '',
      show,
      onClose = () => {
        /*noop*/
      },
    } = this.props;

    const t = this.t;

    return (
      <Modal
        show={show}
        onClose={() => callOnClose && onClose()}
        size="S"
        headerComponent={title}
        primaryAction={call2action}
        onAccept={() => this.validate() && this.handleSubmit()}
      >
        <Flexer.Parent alignItems="center">
          <Flexer.Child>
            <StyledFieldWrapper
              label="Country (ES, UK, FR, NL, PT...)"
              value={country}
              onChange={(e, { value = '' }) => {
                this.setState({ country: value });
              }}
              size="L"
              required
            />
            <StyledFieldWrapper
              label={this.getError('zipcode') || t.zip_code}
              fieldRef={(ref) => (this.postalCodeField = ref)}
              value={address.zipcode || ''}
              maxLength="20"
              onChange={this.guessCity.bind(this)}
              onKeyUp={this.handleKeyUp.bind(this)}
              size="L"
              required
              invalid={this.getError('zipcode')}
            />
            <StyledFieldWrapper
              label={this.getError('city') || t.city}
              value={city || ''}
              onChange={(_, { value = '' }) => {
                this.setState({ city: value });
              }}
              size="L"
              required
              invalid={this.getError('city')}
            />
          </Flexer.Child>
          <Flexer.Child flexGrow="1" pLeft="S">
            {loading ? <Loading /> : <StyledSuccess>{city}</StyledSuccess>}
          </Flexer.Child>
        </Flexer.Parent>

        <div>
          <StyledFieldWrapper
            label={this.getError('company_name') || t.company_name}
            value={address.company_name || ''}
            maxLength="200"
            onChange={(e, { value: company_name }) => {
              this.dirtify('company_name');
              this.setAddress({ company_name });
            }}
            onKeyUp={this.handleKeyUp.bind(this)}
            size="L"
            fullWidth
            required
            invalid={this.getError('company_name')}
          />
          <StyledFieldWrapper
            label={this.getError('address_line') || t.address}
            value={address.address_line || ''}
            maxLength="255"
            onChange={(e, { value: address_line }) => {
              this.dirtify('address_line');
              this.setAddress({ address_line });
            }}
            size="L"
            onKeyUp={this.handleKeyUp.bind(this)}
            multiline
            fullWidth
            required
            invalid={this.getError('address_line')}
          />
          <StyledFieldWrapper
            label={this.getError('contact_name') || t.contact_name}
            value={address.contact_name || ''}
            maxLength="200"
            onChange={(e, { value: contact_name }) => {
              this.dirtify('contact_name');
              this.setAddress({ contact_name });
            }}
            size="L"
            onKeyUp={this.handleKeyUp.bind(this)}
            fullWidth
            invalid={this.getError('contact_name')}
          />
          <StyledFieldWrapper
            label={this.getError('contact_phone') || t.contact_phone}
            value={address.contact_phone || ''}
            maxLength="15"
            onChange={(e, { value: contact_phone }) => {
              this.dirtify('contact_phone');
              this.setAddress({
                contact_phone: contact_phone
                  .split('')
                  .reduce(
                    (acc, ch) =>
                      (ch >= '0' && ch <= '9') || (acc === '' && ch === '+') ? acc + ch : acc,
                    ''
                  ),
              });
            }}
            size="L"
            onKeyUp={this.handleKeyUp.bind(this)}
            fullWidth
            invalid={this.getError('contact_phone')}
          />
        </div>

        {postalCodeError && <p>{t.unsupported_zipcode_no_region}</p>}
      </Modal>
    );
  }
}

const actionCreators = {
  zipToCity,
};

export default connect(null, actionCreators)(injectIntl(ModalAddressForm));
